import React from "react";
import { Stack } from "@mui/material";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import PhoneIcon from "@mui/icons-material/Phone";
import PhoneCallbackIcon from "@mui/icons-material/PhoneCallback";
import PaymentIcon from "@mui/icons-material/Payment";
import TuneIcon from "@mui/icons-material/Tune";
import { Link, useLocation } from "react-router-dom";
import { rootColors } from "../../utilities/Colors/Colors";

const Sidebar = () => {
  const location = useLocation();
  return (
    <Stack
      sx={{
        boxSizing: "border-box",
        width: "300px",
        position: "fixed",
        top: "3rem",
        left: 0,
        bottom: 0,
        flex: "0 0 auto",
        bgcolor: rootColors?.grey,
        padding: "44px 32px",
        gap: 3,
        display: { xs: "none", md: "flex" },
      }}
    >
      {navLinks?.map((item, index) => (
        <Link
          key={index}
          to={item?.path}
          style={{ textDecoration: "none", color: rootColors?.text }}
        >
          <Stack
            sx={{
              flexDirection: "row",
              gap: "16px",
              alignItems: "center",
            }}
          >
            <Stack
              sx={{
                bgcolor:
                  location?.pathname === item?.path
                    ? rootColors?.primary
                    : null,
                borderRadius: "8px",
                padding: "8px",
              }}
            >
              {item?.icon}
            </Stack>
            <Stack sx={{ fontSize: "16px", fontWeight: 400 }}>
              {item?.title}
            </Stack>
          </Stack>
        </Link>
      ))}
    </Stack>
  );
};

export default Sidebar;

const navLinks = [
  {
    title: "Assistants",
    path: "/assistants",
    icon: (
      <AccountBoxIcon
        sx={{
          width: "23.33px",
          height: "23.33px",
          color: "white",
        }}
      />
    ),
  },
  {
    title: "Phone Numbers",
    path: "/phonenumbers",
    icon: (
      <PhoneIcon
        sx={{
          width: "23.33px",
          height: "23.33px",
          color: "white",
        }}
      />
    ),
  },
  {
    title: "Call Logs",
    path: "/calllogs",
    icon: (
      <PhoneCallbackIcon
        sx={{
          width: "23.33px",
          height: "23.33px",
          color: "white",
        }}
      />
    ),
  },
  {
    title: "Billing",
    path: "/billing",
    icon: (
      <PaymentIcon
        sx={{
          width: "23.33px",
          height: "23.33px",
          color: "white",
        }}
      />
    ),
  },
  {
    title: "Accounts",
    path: "/accounts",
    icon: (
      <TuneIcon
        sx={{
          width: "23.33px",
          height: "23.33px",
          color: "white",
        }}
      />
    ),
  },
];
